module.exports = __webpack_public_path__ + "img/kele1.e986d4c6.jpg";